import React from 'react'

function Chatbot() {
  return (
    <div>Chatbot</div>
  )
}

export default Chatbot